import React,{useState, useEffect} from 'react';
import Colors from '../../config/colors'
import GeneralStyles from '../../routes/GeneralStyles.module.scss'

export default function CustomTextFieldPlain({label, onChange, value, placeholder, disabled, width, marginTop, height, backgroundColor, hidden, enterPressed}) {
	return (
		<div
			style={{width: width || '100%', marginTop: marginTop || 0}}>
			<input
				disabled={disabled || false}
				type={hidden ? "password" : "text"}
				id={label}
				placeholder={placeholder}
				value={value}
				autoFocus={true}
				style={
					{
						height: height || 25,
						width: '100%',
						backgroundColor: backgroundColor || Colors.contentBackgroundColor,
						borderRadius: 10,
						color: Colors.primaryTextColor,
						borderWidth: 0,
						fontSize: 15
					}}
				onChange={(e) => onChange(e.target.value)}
				onKeyDown={(e) => {
					if (e.key === "Enter")
						enterPressed();
				}}
			/>
		</div>
	)
}

